import { Node, ReactNodeViewRenderer } from '@tiptap/react'
import { type Dispatch } from 'react'
import { type tabs } from '#app/components/ui/customizer-bar/editor-bar-email.js'
import Component from './component'

export type ColumnOptions = {
	/*
	 * The tab state from the action bar
	 */
	setTab?: Dispatch<React.SetStateAction<tabs>>
}

export const Column = Node.create({
	name: 'column',
	group: 'block',
	content: 'block?',
	defining: true,
	addAttributes() {
		return {
			width: {
				default: null,
			},
		}
	},
	addOptions() {
		return {
			setTab: null,
		}
	},
	parseHTML() {
		return [{ tag: this.name }]
	},
	renderHTML({ node }) {
		const width = node.attrs.width
		return [
			this.name,
			{
				'data-type': 'column',
				valign: 'top',
				width: width,
				style: `vertical-align: top; width: ${width};`,
			},
			0,
		]
	},
	addNodeView() {
		return ReactNodeViewRenderer(Component)
	},
})
